import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { catchApiError } from '@cbridge-packages/api-base';
import { ISupersetApiDependencySegment } from '@cbridge-packages/api-superset';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { SupersetAction } from '../superset.action';
import { SupersetTranslator } from '../superset.translator';

type IDependencies = ISupersetApiDependencySegment;

export const loadChartListEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOf(SupersetAction.loadChartList.started),
  mergeMap(() => {
    return dependencies.supersetApi.getCharts().pipe(
      mergeMap((response) => {
        return [
          SupersetAction.loadChartList.done({
            params: undefined,
            result: response.result?.map(SupersetTranslator.fromApiListItem),
          }),
        ];
      }),
      catchApiError((error) => {
        return [
          SupersetAction.loadChartList.failed({ params: undefined, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
